import { render, staticRenderFns } from "./RefererProgram.vue?vue&type=template&id=0a8ad98a&scoped=true&"
import script from "./RefererProgram.vue?vue&type=script&lang=js&"
export * from "./RefererProgram.vue?vue&type=script&lang=js&"
import style0 from "./RefererProgram.vue?vue&type=style&index=0&id=0a8ad98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ad98a",
  null
  
)

export default component.exports